/** Name key and shard id; must match name_key()/shard_of() in scripts/build_data.py. */

export function stripAccents(s: string): string {
  return s.normalize("NFKD").replace(/\p{M}/gu, "");
}

export function nameKey(raw: string): string {
  const s = stripAccents(raw).toLowerCase().replace(/[’`]/g, "'");
  return s.replace(/[^a-z'\-]/g, "").replace(/^[-']+|[-']+$/g, "");
}

export function fnv1a(s: string): number {
  let h = 0x811c9dc5;
  for (const b of new TextEncoder().encode(s)) {
    h ^= b;
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h >>> 0;
}

export function shardOf(key: string): string {
  return (fnv1a(key) & 0xff).toString(16).padStart(2, "0");
}
